var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videowrapper"},[_c('div',{attrs:{"id":"player2"}}),(_vm.vueSliderStatus && !_vm.fullMode)?_c('vueSlider'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }